import { useState, useCallback } from 'react';
import { useAppState, useDispatch } from '../state/AppContext';
import { ADD_SEED_ARTIST } from '../state/actions';
import { pickRelatedArtist } from '../api/musicClient';
import '../styles/chips.css';

function RelatedArtistChip() {
  const { seedArtists } = useAppState();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(async (e) => {
    if (loading || seedArtists.length === 0) return;
    // Drop focus immediately so mobile taps don't leave the chip in a
    // sticky :focus / :hover state after the new chip mounts.
    e.currentTarget.blur();
    setLoading(true);
    try {
      // Pick relative to a random existing seed so multi-click rotates
      // through different "neighborhoods" rather than draining one seed's pool.
      const sourceSeed = seedArtists[Math.floor(Math.random() * seedArtists.length)];
      const excludeNames = seedArtists.map((a) => a.name);
      const picked = await pickRelatedArtist(sourceSeed, excludeNames);
      if (picked) {
        dispatch({ type: ADD_SEED_ARTIST, payload: picked });
      }
    } catch (err) {
      console.warn('Related-artist pick failed:', err);
    } finally {
      setLoading(false);
    }
  }, [loading, seedArtists, dispatch]);

  return (
    <button
      type="button"
      className={`artist-chip artist-chip-related${loading ? ' is-loading' : ''}`}
      onClick={handleClick}
      disabled={loading}
      aria-label="Add a related artist"
    >
      <span className="chip-related-icon" aria-hidden="true">
        {loading ? (
          <span className="chip-related-spinner" />
        ) : (
          '+'
        )}
      </span>
      <span className="chip-name chip-related-label">
        {loading ? 'Finding artist…' : 'related artist'}
      </span>
    </button>
  );
}

export default RelatedArtistChip;
